import { requestHandler } from '../../api';

export const getAllBankAccounts = async (dispatch: any) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/company/bankAccounts`,
    dispatch,
  });
  if (response) return response.data;
};

export const getOwnBankAccounts = async (dispatch: any) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/bankAccount/own`,
    dispatch,
  });
  if (response) return response.data;
};

export const getBusinessBankAccounts = async (
  dispatch: any,
  businessId: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/business/${businessId}/open/bankAccounts`,
    dispatch,
  });
  if (response) return response.data;
};

export const createBusinessBankAccount = async (
  dispatch: any,
  businessId: string,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/business/${businessId}/open/bankAccounts`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const deleteBusinessBankAccount = async (
  dispatch: any,
  businessId: string,
  data: any,
) => {
  const response = await requestHandler({
    method: 'delete',
    url: `internal/business/${businessId}/open/bankAccounts/${data.bankAccountId}`,
    dispatch,
  });
  if (response) return response.data;
};

export const updateBusinessBankAccount = async (
  dispatch: any,
  businessId: string,
  bankAccountId: number,
  data: any,
) => {
  const response = await requestHandler({
    method: 'patch',
    url: `internal/business/${businessId}/open/bankAccounts/${bankAccountId}`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const selectBankAccount = async (
  dispatch: any,
  businessId: string,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/business/${businessId}/open/bankAccounts/${data.bankAccountId}/select`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const getBankAccountById = async (
  dispatch: any,
  businessId: string,
  bankAccountId: number,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/business/${businessId}/open/bankAccounts/${bankAccountId}`,
    dispatch,
  });
  if (response) return response.data;
};
